export default __webpack_public_path__ + "static/media/Note_Taker.1ede628a.png";